// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_WALL = "Ze\u010f";
export const TAB_BLOGS_POPULAR = "Popul\u00e1rn\u00ed";
